// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5f68727","389":"5fa6541c","732":"fda73a07","977":"51ec43bb"}[chunkId] + ".chunk.js";
};